export const config = {
	"pwa": "https://ops-link.congreet.com",
	"prodPwa": "https://community.online-print-symposium.de",
	"deeplink": "https://ops-link.congreet.com",
	"appStoreLink": "https://apps.apple.com/us/app/skillsclub/id6443815634",
	"playStoreLink": "https://play.google.com/store/apps/details?id=de.onlineprintsymposium.app",
	"availableLangs": [
		"en",
		"de"
	],
	"hideSidebarPublicPages": false,
	"publicPagesLang": false,
	"hideLogout": false,
	"hideSettingsPasswordReset": false,
	"atsAnonymous": true,
	"noIframeRediret": "",
	"showInstallPrompt": true,
	"showCredentialWallet": false,
	"hideRatingInMembers": false,
	"sameSiteAssets": true,
	"maxAppointmentBlockSize": 60,
	"liveTranslation": false,
	"liveTranslationProd": false,
	"benefitUrl": {
		"en": "https://www.congreet.com/en/features-community-software-en/",
		"de": "https://www.congreet.com/de/features-community-software/"
	},
	"linkedIn": {
		"clientId": "787ej8557wujyj"
	},
	"mobileAppId": "de.onlineprintsymposium.app",
	"customScheme": "ops",
	"assets": "https://ops.coolgreet.de",
	"assetsProd": "https://community.online-print-symposium.de",
	"trackingWhitelist": {
		"skillsclub.coolgreet.de": {
			"siteId": 3,
			"exclude": [
				"lost-password",
				"set-password",
				"login",
				"register",
				"toc",
				"credentials/",
				"credential/",
				"mail-setting",
				"deeplink",
				"unsubscribe",
				"preview-attendee-detail"
			],
			"communityWhitelist": {
				"610": 3
			}
		},
		"app.skillsclub.com": {
			"tracker": "https://matomo.skillsclub.com",
			"siteId": 4,
			"exclude": [
				"lost-password",
				"set-password",
				"login",
				"register",
				"toc",
				"credentials/",
				"credential/",
				"mail-setting",
				"deeplink",
				"unsubscribe",
				"preview-attendee-detail"
			],
			"communityWhitelist": {
				"655": 4
			}
		},
		"localhost": {
			"siteId": 1,
			"communityWhitelist": {
				"518": 2,
				"527": 1
			}
		}
	},
	"features": {
		"countryDropdown": {
			"app.skillsclub.com": {
				"communities": []
			},
			"v15.skillsclub.com": {
				"communities": [
					655
				]
			},
			"skillsclub.coolgreet.de": {
				"communities": [
					610
				]
			},
			"localhost": {
				"communities": [
					527
				]
			}
		},
		"limitedMemberList": {
			"app.skillsclub.com": {
				"communities": [
					655
				]
			},
			"v15.skillsclub.com": {
				"communities": [
					655
				]
			},
			"skillsclub.coolgreet.de": {
				"communities": [
					610
				]
			},
			"localhost": {
				"communities": [
					527
				]
			}
		},
		"disableInteraction": {
			"app.skillsclub.com": {
				"communities": []
			},
			"v15.skillsclub.com": {
				"communities": [
					655
				]
			},
			"skillsclub.coolgreet.de": {
				"communities": [
					610
				]
			},
			"localhost": {
				"communities": [
					527
				]
			}
		},
		"disableMessages": {
			"app.skillsclub.com": {
				"communities": []
			},
			"v15.skillsclub.com": {
				"communities": [
					655
				]
			},
			"skillsclub.coolgreet.de": {
				"communities": [
					610
				]
			},
			"localhost": {
				"communities": [
					527
				]
			}
		}
	}
}